import React from 'react';
import SaveDistrict from './save-district';
import Classification from './classifications/Classification';

const Footer = props => {
    const m2Tokm2 = (area) => Math.round(area / 1000000);
    const format = (num) => num.toLocaleString('en').replace(',', ' ');
    return (
        <div className="create-district-map__footer">
            <div className="create-district-map__footer-cols">
                <div className="create-district-map__footer-col">
                    <h2 className="create-district-map__footer-heading">
                        {props.name &&
                            <span>{props.name !== '' ? `${props.name}:` : 'Nytt säljdistrikt:'}</span>
                        }&nbsp;Distriktsarea
                    </h2>
                    <span className="create-district-map__footer-value">{format(m2Tokm2(props.area || 0))} km2</span>
                </div>
                <div className="create-district-map__footer-col">
                    <h2 className="create-district-map__footer-heading">Antal valda {props.type === 'foodservice' ? 'enheter' : 'butiker'}</h2>
                    <span className="create-district-map__footer-value">{props.numberOfUnits || 0}</span>
                </div>
                {props.type !== 'foodservice' &&
                    <>
                        <div className="create-district-map__footer-col">
                            <h2 className="create-district-map__footer-heading">Omsättning</h2>
                            <span className="create-district-map__footer-value">{format(props.turnOver || 0)} KKR</span>
                        </div>
                        <Classification {...props} />
                        {/*                        
                        <div className="create-district-map__footer-col">
                            <h2 className="create-district-map__footer-heading">Butikernas säljyta</h2>
                            <span className="create-district-map__footer-value">{format(props.retailArea || 0)} m2</span>
                        </div>
                        */}
                    </>
                }
            </div>
            <SaveDistrict {...props} />
        </div>
    );
};

export default Footer;